export enum GlobalEvent {
  Filter = 'Filter',
  FilterSelection = 'FilterSelection',
  FromFilterPane = 'FromFilterPane',
  AddItem = 'AddItem',
  UpdateItem = 'UpdateItem',
  SortItems = 'SortItems',
  CreateEntity = 'CreateEntity',
  CreatePost = 'CreatePost',
  OpenFieldSettings = 'OpenFieldSettings',
  CategoryFilter = 'CategoryFilter',
}
